export default "__VITE_ASSET__CIJfWg65__"